type Props = {
  id?: string;
};

const PendoPlaceholder = ({ id = 'pendo-page-guide-placeholder' }: Props) => {
  return <div id={id} className="size-10 shrink-0" />;
};

export default PendoPlaceholder;
